import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import CollapsibleSection from '../../../../Core/CollapsibleSection/CollapsibleSection';
import VersionHistory from '../../../../utils/VersionHistory';
import { useState } from 'react';
import GetIcon from '../../../../utils/Icon';

const Tab1 = ({ bomItem,company,currency,Quantity,checkbox ,RateOfMaterial,po_response,activityboll}) => {
  const options = [
    { name: "Valuation Rate" },
    { name: "Last Purchase Rate" },
    { name: "Price List" }
  ];
  const [showActivity, setShowActivity] = useState(true);
  
  return (
    <div
      className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px",height: '72vh', overflowY: 'scroll',flexWrap:'nowrap'}}
    >
      <div className="col-12 ">
        <div className={bomItem.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={bomItem.bom_item_list}
            label="Item Name"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={bomItem.select_bom_item}
            onChange={(val) => bomItem.setselect_bom_item(val)}
          />
          <p style={{fontSize:'0.7rem',paddingLeft:'4px'}}>Item to be manufactured or repacked</p>
        </div>
      </div>

       <div className="col-12 ">
        <div className={company.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={company.company_list}
            label="Company"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={company.select_company}
            onChange={(val) => company.setselect_company(val)}
          />
        </div>
      </div>
       <div className="col-12 ">
        <div className={`mb-3`}>
           <Input
            id="sno"
            label="Quantity"
            style={{ height: "30px",border:Quantity.Error ? "1px solid red" : '' }}
            value={Quantity.Quantity}
            onChange={(e) => Quantity.setQuantity(e.target.value)}
          />
          <p style={{fontSize:'0.7rem',paddingLeft:'4px',position:'relative',top:'-6px'}}>Quantity of item obtained after manufacturing / repacking from given quantities of raw materials</p>

        </div>
      </div>
      <div className="col-12 ">
        <div className={`mb-2`}>
          <input type="checkbox" name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}} 
          checked={checkbox.isActive} 
          onChange={(val) => checkbox.setisActive(!checkbox.isActive)}
           id="IsActive" />
          <label htmlFor="IsActive" style={{fontSize:'0.8rem',position:'relative',top:'-2px',paddingLeft:'7px'}}>Is Active</label>
        </div>
      </div>
      <div className="col-12 ">
        <div className={`mb-2`}>
          <input type="checkbox" name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}} 
       checked={checkbox.isDefault} 
          onChange={(val) => checkbox.setisDefault(!checkbox.isDefault)}
           id="IsDefault" />
          <label htmlFor="IsDefault" style={{fontSize:'0.8rem',position:'relative',top:'-2px',paddingLeft:'7px'}}>Is Default</label>
        </div>
      </div>
      <div className="col-12 ">
        <div className={`mb-2`}>
          <input type="checkbox" name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}} 
          checked={checkbox.AllowAlternativeItem} 
          onChange={(val) => checkbox.setAllowAlternativeItem(!checkbox.AllowAlternativeItem)}
           id="allow" />
          <label htmlFor="allow" style={{fontSize:'0.8rem',position:'relative',top:'-2px',paddingLeft:'7px'}}>Allow Alternative Item</label>
        </div>
      </div>
      <div className="col-12 ">
        <div className={`mb-2`}>
          <input type="checkbox" name="IsGroup" className="form-check-input" style={{backgroundColor:'#270b79',borderColor:'#270b79'}} 
          checked={checkbox.rateofsubassembly} 
          onChange={(val) => checkbox.setrateofsubassembly(!checkbox.rateofsubassembly)}
           id="rate" />
          <label htmlFor="rate" style={{fontSize:'0.8rem',position:'relative',top:'-2px',paddingLeft:'7px'}}>Set rate of sub-assembly item based on BOM</label>
        </div>
      </div>
     

      <CollapsibleSection title="Cost Configuration">
        <div className="col-12 ">
        <div className={RateOfMaterial.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={options}
            label="Rate Of Materials Based On"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={RateOfMaterial.RateOfMaterials}
            onChange={(val) => RateOfMaterial.setRateOfMaterials(val)}
          />
        </div>
      </div>
        <div className="col-12 ">
        <div className={currency.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={currency.currency_list}
            label="Currency"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={currency.currency}
            onChange={(val) => currency.setcurrency(val)}
          />
        </div>
      </div>
      </CollapsibleSection>


      <div >
      
              <div className="col-12">
                <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
                  <p className="firstcolor m-0">
                    Activity
                  </p>
                  <GetIcon
                    iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
                    size={22}
                  />
                </div>
      
                {showActivity && (
                  <VersionHistory doctype="BOM" docname={po_response?.data?.name} activityboll={activityboll} />
      
                )}
              </div>
      
      
            </div>

    </div>
  )
}

export default Tab1